export default "__VITE_ASSET__BVgck0HX__"